import { connect } from 'react-redux';

import config from '@dom/config';
import ReviewsBox from './ReviewsBox';

import {
  addReply,
  addReview,
  deleteReply,
  fetchReviews,
  deleteReview,
  resetReviews,
  hasBeenUpdated,
} from '@dom/app/dist/actions/reviews';
import { openLoginModal } from '@dom/app/dist/actions/auth';
import { sendRatings, fetchRatings, resetRatings } from '@dom/app/dist/actions/ratings';

const mapStateToProps = ({
  reviews: { reviews, onUpdated },
  ratings: { ratings },
  user,
}) => ({
  reviews: reviews && sortReviewsToLatest(reviews),
  numberOfReviews: reviews.length,
  onUpdated,
  ratings: (ratings && hasKeys(ratings) && ratings) || null,
  userImageURI: user && decideImage(user),
  isLoggedIn: Boolean(user.userId),
});

const hasKeys = obj => Object.keys(obj).length > 0;

const sortReviewsToLatest = reviews =>
  reviews.sort((a, b) => new Date(b.reviewedOn) - new Date(a.reviewedOn));

const decideImage = user => {
  const { primaryImage, profileImage } = user;

  if (primaryImage) return `${config.RESOURCE_URL}/${primaryImage}`;
  if (profileImage) return profileImage;

  return null;
};

//origin refers to the page where the action is fired.
//It could be on TrekOverview as treks, LodgeDetails as lodge or Guide Profile as profile

const mapActionToProps = (dispatch, { origin }) => ({
  openLoginModal: () => dispatch(openLoginModal()),
  sendRatings: (ratings, token) => dispatch(sendRatings(ratings, origin, token)),
  fetchReviews: () => dispatch(fetchReviews(origin)),
  addReview: (review, userInfo) => dispatch(addReview(review, origin, userInfo)),
  addReply: (review, id) => dispatch(addReply(review, id, origin)),
  deleteReview: id => dispatch(deleteReview(id, origin)),
  deleteReply: id => dispatch(deleteReply(id, origin)),
  resetReviews: () => dispatch(resetReviews()),
  resetRatings: () => dispatch(resetRatings()),
  hasBeenUpdated: () => dispatch(hasBeenUpdated()),
  fetchRatings: () => dispatch(fetchRatings(origin)),
});

export default connect(
  mapStateToProps,
  mapActionToProps
)(ReviewsBox);
